export default __webpack_public_path__ + "static/media/POLAD.74bae7f1.svg";